import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLock = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 17,
	height: 16,
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		d: "M13.167 4.667v.949c.594.259 1.099.686 1.454 1.227s.545 1.175.546 1.823v4c-.001.884-.353 1.731-.977 2.356a3.34 3.34 0 0 1-2.356.977H5.167c-.884-.001-1.731-.353-2.356-.977s-.976-1.472-.977-2.356v-4c.001-.648.19-1.281.546-1.823s.861-.968 1.454-1.227v-.949c0-1.238.492-2.425 1.367-3.3S7.262 0 8.5 0s2.425.492 3.3 1.367 1.367 2.062 1.367 3.3zM6.143 2.31c-.625.625-.976 1.473-.976 2.357v.667h6.667v-.667c0-.884-.351-1.732-.976-2.357S9.384 1.333 8.5 1.333s-1.732.351-2.357.976zm7.105 11.771a2 2 0 0 0 .586-1.414v-4a2 2 0 0 0-2-2H5.167a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h6.667a2 2 0 0 0 1.414-.586zM8.029 9.529c.125-.125.295-.195.471-.195s.346.07.471.195.195.295.195.471v1.333c0 .177-.07.346-.195.471S8.677 12 8.5 12s-.346-.07-.471-.195-.195-.295-.195-.471V10c0-.177.07-.346.195-.471z",
		fill: "currentColor"
	})
});
export default SvgLock;
